import { render } from "./PlatformItem.vue?vue&type=template&id=6c4cf756"
import script from "./PlatformItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PlatformItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c4cf756"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c4cf756', __exports__)) {
    api.reload('6c4cf756', __exports__)
  }
  
  module.hot.accept("./PlatformItem.vue?vue&type=template&id=6c4cf756", () => {
    api.rerender('6c4cf756', render)
  })

}


export default __exports__